var map = {
	"./de.json": [
		894,
		894
	],
	"./en.json": [
		174,
		174
	],
	"./es.json": [
		725,
		725
	],
	"./fr.json": [
		605,
		605
	],
	"./vn.json": [
		809,
		809
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96;
module.exports = webpackAsyncContext;